import { Component, OnInit, Input } from '@angular/core';
import { PaginatorUtil } from '../../util/paginator/paginator.util';

/**
 * A wrapper around the mat-paginator component that integrates it with Leatherman's paginator utility
 */
@Component({
  selector: 'lm-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class DfPaginatorComponent {
  /** A reference to a paginator utility */
  @Input()
  public paginator: PaginatorUtil<any>;
}
